const { Tag, Table } = require("antd");

function normalizeConflicts(conflicts) {
    const rows = [];

    (conflicts || []).forEach((c, i) => {
        if (c.type === "duplicateFieldReference") {
            (c.occurrences || []).forEach(o => {
                rows.push({
                    key: `${c.fieldName}-${o.form}-${o.field}`,
                    problem: "Campo duplicado",
                    field: c.fieldName,
                    origin: o.field,
                    usage: o.type,
                    target: o.form
                });
            });
        } else if (c.type === 'searchAndReturnConflict') {
            rows.push({
                key: `conflict-${i}`,
                problem: "Conflito busca/retorno",
                field: c.fieldName,
                origin: c.target,
                usage: c.formSearch,
                target: c.formReturn
            });
        }
        else {
            rows.push({
                key: `conflict-${i}`,
                problem: "Conflito de nome",
                field: c.field,
                origin: c.target,
                usage: c.type,
                target: c.form
            });
        }
    });

    return rows;
}

const getColumns = ({ firstColumn = "Problema", secondColumn = "Campo selecionado", thirdColumn = "Campo pai", fourthColumn = "Formulário" } = {}) => [
    {
        title: firstColumn,
        dataIndex: "problem",
        render: v => <Tag color="red">{v}</Tag>,
        ellipsis: true
    },
    {
        title: secondColumn,
        dataIndex: "field",
        render: v => <Tag color="orange">{v}</Tag>,
        ellipsis: true
    },
    {
        title: thirdColumn,
        dataIndex: "usage",
        ellipsis: true
    },
    {
        title: fourthColumn,
        dataIndex: "target",
        ellipsis: true
    }
]

export default function ConflictTable(props) {
    const data = normalizeConflicts(props.conflicts);
    const columns = getColumns(props.columnLabels);

    return (
        <Table
            size="small"
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            locale={{ emptyText: "Nenhum conflito encontrado." }}
        />
    );
}